<template>
  <footer class="bg-secondary text-white pt-10">
    <div class="max-w-7xl mx-auto px-6 flex flex-col md:flex-row gap-8">
      <!-- Tier gauche : Logo -->
      <div class="md:w-1/3 flex items-center justify-center md:justify-start mb-6 md:mb-0">
        <!-- <img src="@/assets/logo.png" alt="Nailit Logo" class="h-12" /> -->
        <router-link to="/" class="text-[80px] font-bold cursor-pointer">
          Nailit
        </router-link>
      </div>
      <!-- 3 colonnes de liens -->
      <div class="md:w-2/3 grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div>
          <h3 class="font-bold mb-3 uppercase text-sm tracking-wider">Produit</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/features" class="hover:underline">
                Fonctionnalités
              </router-link>
            </li>
            <li>
              <router-link to="/pricing" class="hover:underline">
                Tarifs
              </router-link>
            </li>
            <li>
              <router-link to="/ShowPlanning" class="hover:underline">
                Essai gratuit
              </router-link>
            </li>
          </ul>
        </div>
        <div>
          <h3 class="font-bold mb-3 uppercase text-sm tracking-wider">Ressources</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/blog" class="hover:underline">
                Blog
              </router-link>
            </li>
            <li>
              <router-link to="/contact" class="hover:underline">
                Aide
              </router-link>
            </li>
          </ul>
        </div>
        <div>
          <h3 class="font-bold mb-3 uppercase text-sm tracking-wider">Entreprise</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/contact" class="hover:underline">
                A propos
              </router-link>
            </li>
            <li>
              <router-link to="/contact" class="hover:underline">
                Contact
              </router-link>
            </li>
            <li>
              <span class="hover:underline cursor-pointer" @click="popupVisible = true">
                Mentions légales
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Ligne du bas -->
    <div class="border-t border-gray-700 mt-8 py-4 text-xs text-gray-400 text-center">
      © {{ new Date().getFullYear() }} Nailit. Tous droits réservés.
    </div>
  </footer>
  <Popup :visible="popupVisible" :noButtons="true" title="Mentions légales" @close="popupVisible = false">
    <div class="text-sm text-gray-700 space-y-4 max-w-lg">
      <div>
        <strong>Éditeur du site :</strong><br>
        Nailit Planning<br>
        9 Bellean, 56130 Marzan, France<br>
        SIRET : En cours<br>
        contact@nailit-planning.com
      </div>
      <div>
        <strong>Directeur de la publication :</strong><br>
        Bougio Néo
      </div>
      <div>
        <strong>Hébergement :</strong><br>
        Vercel.inc<br>
        340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis<br>
        www.vercel.com
      </div>
      <div>
        <strong>Propriété intellectuelle :</strong><br>
        L'ensemble du contenu du site Nailit (textes, images, logo, etc.) est protégé par le droit d'auteur. Toute reproduction, même partielle, est interdite sans autorisation préalable.
      </div>
      <div>
        <strong>Données personnelles :</strong><br>
        Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour toute demande, contactez-nous à l'adresse ci-dessus.
      </div>
    </div>
</Popup>
</template>

<script>

import Popup from '../Popups/Popup.vue';

export default {
  name: 'Footer',
  components: {
    Popup,
  },
  data(){
    return{
      popupVisible: false,
    }
  }
};

</script>